import { useUpdateDormakabaConnection } from '@/api/property-keyless/dormakaba/update-dormakaba-connection'

import { DormakabaConnectionFormValues } from './dormakaba.schema'

export const useDormakabaSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateDormakabaConnection()

  const submit = (values: DormakabaConnectionFormValues) =>
    mutateAsync({
      buildingId,
      clientId: values.clientId,
      clientSecret: values.clientSecret,
      config: values.config ? (JSON.parse(values.config) as Record<string, unknown>) : undefined,
      host: values.host,
      password: values.password,
      protocol: values.protocol,
      requesterId: values.requesterId,
      scope: values.scope,
      tokenHost: values.tokenHost,
      tokenProtocol: values.tokenProtocol,
      username: values.username,
    })

  return { isPending, submit }
}
